export const GuidEmpty = '00000000-0000-0000-0000-000000000000';

export const Steps = {
    DEFAULT: 0,
    HOME: 1,
    RESTAURANT_SEARCH: 2,
    TABLE_PICKER: 3,
    BILL: 4,
    APPLY_GRATUITY: 5,
    PAY: 6,
    PAYMENT_CONFIRMATION: 7,
    APPLY_VOUCHER: 8,
    REGISTER: 9,
    FORGOTTEN_PASSWORD: 10,
    SPLIT_BILL_MENU: 11,
    SPLIT_BILL_NAME: 12,
    ORDER_OR_PAY: 13,
    PRE_ORDER_DATA_CAPTURE: 14,
    PRE_ORDER: 15,
    CONTENT_PAGE: 16
};

export const GetStepName = (stepId) => {
    return Object.keys(Steps).find((step) => Steps[step] === stepId);
}

export const SplitType = {
    None: 0,
    SplitByAmount: 1,
    SplitByItem: 2
};